'use client';
var classes = {"root":"m_fa528724","svg":"m_62e9e7e2","filledSegment":"m_c573fb6f","label":"m_4fa340f2"};

export { classes as default };
//# sourceMappingURL=SemiCircleProgress.module.css.mjs.map
